export const RouteTankEditPage = '/tanks/:id/edit';
export const RouteTankNewPage = '/tanks/new';
export const RouteVehicleEditPage = '/vehicles/:id/edit';
export const RouteVehicleNewPage = '/vehicles/new';
